
export default {
  props: {
    files: Array,
  },
};
